import { Injectable, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import ValidatorUtils from '@core/utils/validator.utils';
import {
  DvCheckboxElement,
  DvSpaceElement,
  DvTimePickerElement,
} from '@devinco/ui/legacy';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TripTypeSetupDialogFormService {
  private translate = inject(TranslateService);

  readonly timeElements = [
    new DvTimePickerElement({
      key: 'From',
      label: 'TripTypeSetupGrid.From',
      colspan: 6,
      validators: [
        ValidatorUtils.timeRangeValidator('To'),
        Validators.required,
      ],
    }),
    new DvTimePickerElement({
      key: 'To',
      label: 'TripTypeSetupGrid.To',
      colspan: 6,
      validators: [
        ValidatorUtils.dateTimeRangeEndValidator('From'),
        Validators.required,
      ],
    }),
  ];

  readonly weekElements = [
    new DvSpaceElement({ rowspan: 1 }),
    new DvCheckboxElement({
      colspan: 3,
      key: 'Monday',
      checkboxLabel: 'General.DaysOfWeek.Monday',
    }),
    new DvCheckboxElement({
      colspan: 3,
      key: 'Tuesday',
      checkboxLabel: 'General.DaysOfWeek.Tuesday',
    }),
    new DvCheckboxElement({
      colspan: 3,
      key: 'Wednesday',
      checkboxLabel: 'General.DaysOfWeek.Wednesday',
    }),
    new DvCheckboxElement({
      colspan: 3,
      key: 'Thursday',
      checkboxLabel: 'General.DaysOfWeek.Thursday',
    }),
    new DvCheckboxElement({
      colspan: 3,
      key: 'Friday',
      checkboxLabel: 'General.DaysOfWeek.Friday',
    }),
    new DvCheckboxElement({
      colspan: 3,
      key: 'Saturday',
      checkboxLabel: 'General.DaysOfWeek.Saturday',
    }),
    new DvCheckboxElement({
      colspan: 3,
      key: 'Sunday',
      checkboxLabel: 'General.DaysOfWeek.Sunday',
    }),
  ];
}
